import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="species-multiselect"
export default class extends Controller {
  static targets = [
    "search",
    "options",
    "option",
    "selected",
    "hiddenInputs"
  ]

  static values = {
    selectedIds: Array
  }

  connect() {
    // Normalize selected IDs to strings for comparison
    this.selectedSet = new Set((this.selectedIdsValue || []).map(String))
    // Initialize UI state based on preselected ids
    this.optionTargets.forEach((el) => {
      const id = el.dataset.id
      if (this.selectedSet.has(String(id))) {
        this.markSelected(el, true)
      }
    })
    this.renderHiddenInputs()
    this.renderSelectedPills()
  }

  filter() {
    const q = this.searchTarget.value.trim().toLowerCase()
    this.optionTargets.forEach((el) => {
      const text = `${el.dataset.name || ""} ${(el.dataset.alt || "")}`.toLowerCase()
      const show = q.length === 0 || text.includes(q)
      el.classList.toggle("hidden", !show)
    })
  }

  toggle(event) {
    const el = event.currentTarget.closest('[data-species-multiselect-target="option"]') || event.currentTarget
    const id = String(el.dataset.id)
    if (this.selectedSet.has(id)) {
      this.selectedSet.delete(id)
      this.markSelected(el, false)
    } else {
      this.selectedSet.add(id)
      this.markSelected(el, true)
    }
    this.renderHiddenInputs()
    this.renderSelectedPills()
  }

  clearPill(event) {
    const id = String(event.currentTarget.dataset.id)
    // Unselect in set
    this.selectedSet.delete(id)
    // Unselect in list
    const el = this.optionTargets.find((opt) => String(opt.dataset.id) === id)
    if (el) this.markSelected(el, false)
    this.renderHiddenInputs()
    this.renderSelectedPills()
  }

  markSelected(el, selected) {
    el.setAttribute("aria-selected", selected ? "true" : "false")
    el.classList.toggle("bg-indigo-50", selected)
    el.classList.toggle("ring-2", selected)
    el.classList.toggle("ring-indigo-200", selected)
    const checkbox = el.querySelector('input[type="checkbox"]')
    if (checkbox) checkbox.checked = !!selected
  }

  renderHiddenInputs() {
    // Replace hidden inputs with current selected ids
    this.hiddenInputsTarget.innerHTML = ""
    Array.from(this.selectedSet).forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "species_ids[]"
      input.value = id
      this.hiddenInputsTarget.appendChild(input)
    })
  }

  renderSelectedPills() {
    // Render pills for selected items
    this.selectedTarget.innerHTML = ""
    if (this.selectedSet.size === 0) {
      this.selectedTarget.innerHTML = '<span class="text-sm text-gray-500">No species selected</span>'
      return
    }
    const selectedIds = new Set(this.selectedSet)
    this.optionTargets.forEach((el) => {
      const id = String(el.dataset.id)
      if (!selectedIds.has(id)) return
      const name = el.dataset.name || ""
      const pill = document.createElement("span")
      pill.className = "inline-flex items-center gap-1 rounded-full bg-indigo-100 px-2.5 py-1 text-xs font-medium text-indigo-700 mr-2 mb-2"
      pill.innerHTML = `
        <span>${name}</span>
        <button type="button" aria-label="Remove ${name}" data-id="${id}" data-action="click->species-multiselect#clearPill" class="-mr-1 inline-flex h-5 w-5 items-center justify-center rounded-full text-indigo-600 hover:bg-indigo-200 hover:text-indigo-800">
          &times;
        </button>
      `
      this.selectedTarget.appendChild(pill)
    })
  }
}

